export default {
    userManagement: 'User Management',
    searchByUserName: 'Search by Username',
    search: 'Search',
    createNewMember: 'Create new member',
    userName: 'Username',
    branch: 'Branch',
    role: 'Role',
    joinedAt: 'Joined At',
    contactNo: 'Contact No',
    action: 'Action',
    congratulation: 'Congratulation',
    userIsDeleted: 'User is deleted',
    deleteUser: 'Delete User',
    wantToDelete: 'Are you sure you want to delete'
}
